import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, CTA_LABEL, OFFER } from '../data/checkout';
import { trackCheckout } from '../utils/tracking';
const noMore = ['Niente più serate passate a cercare come spiegare concetti metodologici complessi', 'Niente più lezioni costruite in fretta con materiali sparsi', 'Niente più studenti che conoscono le definizioni ma non sanno applicarle', 'Niente più fine settimana dedicati alla creazione di materiale da zero', 'Niente più valutazioni e attività preparate sotto pressione'];
const everything = ['Volume 1 — Fondamenti della Ricerca Scientifica', 'Volume 2 — Obiettivi, Ipotesi, Variabili e Disegno della Ricerca', 'Volume 3 — Metodi Quantitativi, Qualitativi e Misti', 'Volume 4 — Campionamento, Tecniche e Strumenti di Raccolta dei Dati', 'Volume 5 — Analisi, Interpretazione e Presentazione dei Risultati', 'Volume 6 — Ricerca Bibliografica, Scrittura Accademica e Progetto Finale', 'Bonus 1 — 100 Attività Pronte all’Uso', 'Bonus 2 — Banca di Casi e Progetti di Ricerca', 'Bonus 3 — Kit di Valutazione della Ricerca', 'Bonus 4 — 30 Lezioni di Emergenza', 'Bonus 5 — Laboratorio degli Errori Metodologici', 'Garanzia di 7 giorni', 'Pagamento unico', 'Accesso immediato', 'Formato PDF pronto all’uso'];
const reassurances = ['Garanzia di 7 giorni', 'Pagamento sicuro', 'Accesso immediato', 'Pagamento unico'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-92" data-mp="300snm8kc5pla">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-93" data-mp="34uddtefotf9x" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-94" data-mp="3errrx7e51rz2">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-16" data-id="element-95" data-mp="3et2syzg78lmh">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-96" data-mp="1eqbe5qsjcwk0">
            La prossima settimana puoi continuare a improvvisare...
            <br data-id="element-97" data-mp="1npyhwj8qmeg8" />
            <span className="text-gold-gradient" data-id="element-98" data-mp="1npezz2j37q27">
              Oppure puoi entrare in aula con tutto pronto da oggi.
            </span>
          </h2>

          <ul className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-dark-card p-8 rounded-2xl border border-dark-border" data-id="element-99" data-mp="22d032wfyppa4">
            {noMore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-100" data-mp="2behqz0zm2v9d">
                <span className="text-gold mt-1" aria-hidden="true" data-id="element-101" data-mp="27dxsnu3axlln">
                  ▸
                </span>
                <span className="text-gray-300" data-id="element-102" data-mp="h0ym16394ae1">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl text-white mb-2" data-id="element-103" data-mp="d0et6eppnsxp">
            Metodologia della Ricerca Pro non ti rende un docente migliore.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-104" data-mp="2wrlmqqu99e5">
            Sei già tu a portare competenza ed esperienza in aula.
          </p>
          <p className="text-xl text-gray-300" data-id="element-105" data-mp="3pbsrl6rj6em7">
            Quello che fa Metodologia della Ricerca Pro è darti il tempo, la
            struttura e gli strumenti necessari affinché tutto questo possa
            emergere in ogni lezione.
          </p>
        </motion.div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-106" data-mp="3ffhfagrxxorr">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-dark-border pb-6" data-id="element-107" data-mp="36cycfwo5nc5i">
            Tutto ciò che include:
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-108" data-mp="3bc1jfmnp3sg4">
            {everything.map(item => <li key={item} className="flex items-start gap-3" data-id="element-109" data-mp="14j8tv6ngpg27">
                <CheckIcon size={18} className="text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-110" data-mp="19j3l5bb5g7ns" />
                <span className="text-sm text-gray-200" data-id="element-111" data-mp="30oq1ov0olyn6">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-112" data-mp="2vols7oy6y46g">
            <blockquote className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-113" data-mp="2vnk7stvac5c2">
              “Il momento migliore per avere questo materiale era all’inizio
              dell’anno.
              <br data-id="element-114" data-mp="2mqi4qn3naxc0" />
              <span className="text-gold font-bold not-italic" data-id="element-115" data-mp="2hy8ipi5nihf0">
                Il secondo momento migliore è oggi.
              </span>
              ”
            </blockquote>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-116" data-mp="2cwjbyepgopwq">
              📚 METODOLOGIA DELLA RICERCA PRO
            </p>
            <p className="text-sm text-gray-400 mb-6" data-id="element-117" data-mp="23yh2rbvkqqyd">
              Creato per docenti che vogliono insegnare la metodologia della
              ricerca con più struttura, chiarezza e sicurezza.
            </p>

            <p className="text-4xl font-bold text-gold font-sans mb-8" data-id="element-118" data-mp="eg0plwgc72bf">
              {OFFER.priceLabel}
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6" data-id="element-119" data-mp="jebwpzf8yypy">
              {CTA_LABEL}
            </Button>

            <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-400" data-id="element-120" data-mp="3rwrmcic4axrc">
              {reassurances.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-121" data-mp="3vvh7ix3edjlj">
                  <CheckIcon size={12} className="text-gold" aria-hidden="true" data-id="element-122" data-mp="4qh4sl92cydx" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}